export default __webpack_public_path__ + "static/mobile-menu-bg-9b1491c008c15b86970d6289fa2b5720.png";